import {
  Component,
  OnInit,
  ViewChild,
  Input,
  EventEmitter,
  Output,
  ComponentRef,
  ComponentFactoryResolver,
  SimpleChanges,
  OnChanges,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  ScholarshipSessionDto,
  ScholarshipAwardDurationDto,
  CommunityDto,
  CountryDto,
  LgaDto,
  StateDto,
  ScholarshipTypeDto,
  ScholarshipCategoryDto,
  CourseOfStudyDto,
  EpimsGenderDto,
  EpimsBankDto,
  EpimsBankDetailDto,
  CurrencyDto,
} from '@cradua/data';
import { ReferenceFormDirective } from '../../directives/reference-form.directive';
import { ReferenceFormView } from '../../models/referenceform.interface';
import { CountryViewComponent } from '../../components/country-view/country-view.component';
import { StateViewComponent } from '../../components/state-view/state-view.component';
import { LgaViewComponent } from '../../components/lga-view/lga-view.component';
import { ScholarshipTypeViewComponent } from '../../components/scholarship-type-view/scholarship-type-view.component';
import { CourseofstudyViewComponent } from '../../components/courseofstudy-view/courseofstudy-view.component';
import { ScholarshipCategoryViewComponent } from '../../components/scholarship-category-view/scholarship-category-view.component';
import { ScholarshipSessionViewComponent } from '../../components/scholarship-session-view/scholarship-session-view.component';
import { ScholarshipDurationViewComponent } from '../../components/scholarship-duration-view/scholarship-duration-view.component';
import { CommunityViewComponent } from '../../components/community-view/community-view.component';
import { GenderViewComponent } from '../../components/gender-view/gender-view.component';
import { BankViewComponent } from '../../components/bank-view/bank-view.component';
import { BankDetailViewComponent } from '../../components/bank-detail-view/bank-detail-view.component';
import { CurrencyViewComponent } from '../../components/currency-view/currency-view.component';

const componentMapper = {
  country: CountryViewComponent,
  state: StateViewComponent,
  lga: LgaViewComponent,
  scholarshipType: ScholarshipTypeViewComponent,
  courseOfStudy: CourseofstudyViewComponent,
  scholarshipCategory: ScholarshipCategoryViewComponent,
  scholarshipSession: ScholarshipSessionViewComponent,
  scholarshipAwardDuration: ScholarshipDurationViewComponent,
  community: CommunityViewComponent,
  gender: GenderViewComponent,
  bank: BankViewComponent,
  bankDetail: BankDetailViewComponent,
  currency: CurrencyViewComponent,
};

@Component({
  selector: 'mrsoftapps-reference-form-view',
  templateUrl: './reference-form-view.component.html',
  styleUrls: ['./reference-form-view.component.css'],
})
export class ReferenceFormViewComponent implements OnInit {
  /**Here we grab reference placeholder directive  */
  @ViewChild(ReferenceFormDirective, { static: true })
  placeholder: ReferenceFormDirective;
  // @Input() inputData: StudentListView;
  @Input() data: any;
  inputData: ReferenceFormView;
  @Input() countries: CountryDto[];
  @Input() states: StateDto[];
  @Input() lgas: LgaDto[];
  @Input() scholarshipTypes: ScholarshipTypeDto[];
  @Input() scholarshipCategories: ScholarshipCategoryDto[];
  @Input() courseOfStudies: CourseOfStudyDto[];
  @Input() scholarshipSessions: ScholarshipSessionDto[];
  @Input() scholarshipAwardDurations: ScholarshipAwardDurationDto[];
  @Input() genders: EpimsGenderDto[];
  @Input() communities: CommunityDto[];
  @Input() banks: EpimsBankDto[];
  @Input() bankDetails: EpimsBankDetailDto[];
  @Input() currencies: CurrencyDto[];

  @Output() changeEmit: EventEmitter<string> = new EventEmitter<string>();
  @Output() deleteEvent: EventEmitter<string> = new EventEmitter<string>();

  /**An array where we register what component we want to load */

  componentRef: ComponentRef<any>;
  constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

  ngOnInit() {}
  ngOnChanges(changes: SimpleChanges): void {
    /**
     * We are using this hook for change detection and invoking loadComponent() method
     * There are more ways to do this but for the simplicity of this example I have decided on this way
     */
    if (changes.data) {
      if (changes.data.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.states) {
      if (changes.states.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.lgas) {
      if (changes.lgas.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.scholarshipTypes) {
      if (changes.scholarshipTypes.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.courseOfStudies) {
      if (changes.courseOfStudies.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.scholarshipCategories) {
      if (changes.scholarshipCategories.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.scholarshipSessions) {
      if (changes.scholarshipSessions.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.communities) {
      if (changes.communities.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.scholarshipAwardDurations) {
      if (changes.scholarshipAwardDurations.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.genders) {
      if (changes.genders.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.banks) {
      if (changes.banks.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.bankDetails) {
      if (changes.bankDetails.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    } else if (changes.currencies) {
      if (changes.currencies.currentValue != undefined) {
        // We need to check if inputData has some value

        this.loadComponent();
      }
    }
  }

  /**
   * A method that loads and creates instances of components
   */
  loadComponent() {
    if (this.componentRef) {
      this.componentRef.destroy();
    }

    /** Preparing our component for creation */
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(
      componentMapper[this.data]
    );
    /** Grabbing reference of our view placeholder */
    const viewContainerRef = this.placeholder.viewContainerRef;
    /** Clearing our placeholder  */
    viewContainerRef.clear();
    /** Magic of creating a component instance  */
    this.componentRef = viewContainerRef.createComponent(componentFactory);
    /**
     * @Input data into our instance.
     */

    // (this.componentRef.instance as StudentListView).student = this.inputData.student;
    if (this.data === 'country') {
      (this.componentRef
        .instance as ReferenceFormView).countries = this.countries;
    } else if (this.data === 'state') {
      (this.componentRef
        .instance as ReferenceFormView).countries = this.countries;
      (this.componentRef.instance as ReferenceFormView).states = this.states;
    } else if (this.data === 'lga') {
      (this.componentRef.instance as ReferenceFormView).states = this.states;
      (this.componentRef.instance as ReferenceFormView).lgas = this.lgas;
    } else if (this.data === 'scholarshipType') {
      (this.componentRef
        .instance as ReferenceFormView).scholarshipTypes = this.scholarshipTypes;
      (this.componentRef
        .instance as ReferenceFormView).scholarshipCategories = this.scholarshipCategories;
    } else if (this.data === 'courseOfStudy') {
      (this.componentRef
        .instance as ReferenceFormView).courseOfStudies = this.courseOfStudies;
    } else if (this.data === 'community') {
      (this.componentRef
        .instance as ReferenceFormView).communities = this.communities;
      (this.componentRef.instance as ReferenceFormView).lgas = this.lgas;
    } else if (this.data === 'scholarshipSession') {
      (this.componentRef
        .instance as ReferenceFormView).scholarshipSessions = this.scholarshipSessions;
    } else if (this.data === 'scholarshipAwardDuration') {
      (this.componentRef
        .instance as ReferenceFormView).scholarshipAwardDurations = this.scholarshipAwardDurations;
    } else if (this.data === 'scholarshipCategory') {
      (this.componentRef
        .instance as ReferenceFormView).scholarshipCategories = this.scholarshipCategories;
    } else if (this.data === 'gender') {
      (this.componentRef.instance as ReferenceFormView).genders = this.genders;
    } else if (this.data === 'bank') {
      (this.componentRef.instance as ReferenceFormView).banks = this.banks;
    } else if (this.data === 'bankDetail') {
      (this.componentRef.instance as ReferenceFormView).banks = this.banks;
      (this.componentRef
        .instance as ReferenceFormView).bankDetails = this.bankDetails;
    } else if (this.data === 'currency') {
      (this.componentRef
        .instance as ReferenceFormView).currencies = this.currencies;
    }

    /** @Output data from our instance  */
    this.componentRef.instance.changeEmit.subscribe((data) =>
      this.changeEmit.emit(data)
    );

    this.componentRef.instance.deleteEvent.subscribe((data) =>
      this.deleteEvent.emit(data)
    );
  }
}
